import { render } from "./MovieSlider.vue?vue&type=template&id=63a68925"
import script from "./MovieSlider.vue?vue&type=script&lang=js"
export * from "./MovieSlider.vue?vue&type=script&lang=js"

import "./MovieSlider.vue?vue&type=style&index=0&id=63a68925&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__